import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const ProtectedRoute = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);

  useEffect(() => {
    const verifyToken = async () => {
      const token = localStorage.getItem('admin_token');
      if (!token) {
        setIsAuthenticated(false);
        return;
      }

      try {
        const res = await axios.get(`${API}/admin/verify`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        // Refresh role in case it was changed server-side since the token was issued
        if (res.data?.role) {
          localStorage.setItem('admin_role', res.data.role);
        }
        if (res.data?.username) {
          localStorage.setItem('admin_username', res.data.username);
        }
        setIsAuthenticated(true);
      } catch (error) {
        localStorage.removeItem('admin_token');
        localStorage.removeItem('admin_role');
        localStorage.removeItem('admin_username');
        setIsAuthenticated(false);
      }
    };

    verifyToken();
  }, []);

  if (isAuthenticated === null) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p className="text-slate-500">Verifying...</p>
      </div>
    );
  }

  return isAuthenticated ? children : <Navigate to="/admin/login" replace />;
};

export default ProtectedRoute;